export default "__VITE_ASSET__eDx1PYwh__"